import React from "react";

import { ModalScreenLoadingLottie } from "../../../components";
import {
  ModalScreenStateProps,
  ModalScreenActionTypes,
  Open,
  Content,
} from "../../../utils/types/redux/modalScreen";

const DefaultContent = ModalScreenLoadingLottie;

// ACTION TYPES

const SET_OPEN = "modalScreen/SET_OPEN";
const SET_CONTENT = "modalScreen/SET_CONTENT";

// REDUCER

const initialState: ModalScreenStateProps = {
  open: false,
  content: <DefaultContent />,
};

const reducer = (
  state = initialState,
  action: ModalScreenActionTypes,
): ModalScreenStateProps => {
  switch (action.type) {
    case SET_OPEN:
      return {
        ...state,
        open: action.payload as Open,
      };

    case SET_CONTENT:
      return {
        ...state,
        content: (action.payload as Content) || <DefaultContent />,
      };

    default:
      return state;
  }
};

export default reducer;

// ACTION CREATORS

export const setOpen = (open: Open): ModalScreenActionTypes => ({
  type: SET_OPEN,
  payload: open,
});

export const setContent = (content: Content): ModalScreenActionTypes => ({
  type: SET_CONTENT,
  payload: content,
});
